import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  chip: {
    background: theme.palette.grey[500],
    color: theme.palette.common.white,
  },
  chipIconWrapper: {
    height: 10,
    background: theme.palette.common.white,
    borderRadius: 7,
    padding: 2,
    width: 10,
    marginLeft: 3,
  },
  chipIcon: {
    height: 8,
    position: 'relative',
    top: -1,
    left: 1,
  },
  wrapper: {
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 5,
    fontFamily: theme.palette.medium,
    fontSize: 14,
    padding: 5,
    position: 'relative',
    '& div': {
      margin: 8,
    },
    '&:focus': {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
  input: {
    flex: 1,
    outline: 'none',
    wordBreak: 'break-all',
  },
  label: {
    background: theme.palette.common.white,
    color: theme.palette.grey[500],
    fontSize: 14,
    fontFamily: theme.font.regular,
    left: 6,
    padding: '0 4px',
    position: 'absolute',
    top: -7,
  },
  snippet: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 28,
    color: theme.palette.common.white,
    height: 20,
    minWidth: 50,
    padding: '2px 8px',
    // width: 'max-content',
  },
  snippetsWrapper: {},
}));
